import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { apiDocsTranslationRef } from '@backstage/plugin-api-docs';
import { TranslationBlueprint } from '@backstage/plugin-app-react';

const apiDocsTranslationsMessagesOverride = createTranslationMessages({
  ref: apiDocsTranslationRef,
  full: false,
  messages: {
    'defaultApiExplorerPage.createButtonTitle':
      'Register Existing API Component',
  },
});

const apiDocsTranslationsOverride = createTranslationResource({
  ref: apiDocsTranslationRef,
  translations: {
    en: async () => ({
      default: apiDocsTranslationsMessagesOverride,
    }),
  },
});

export const apiDocsTranslationsOverrideExtension = TranslationBlueprint.make({
  name: 'api-docs-translations-override',
  params: {
    resource: apiDocsTranslationsOverride,
  },
});
